import {useCallback} from 'react';
import {Footer} from '~/SignUpSheets/components/Header/components/SheetOptions/MessageVolunteers/components/Footer';
import {RecipientCount} from '~/SignUpSheets/components/Header/components/SheetOptions/MessageVolunteers/components/RecipientCount';
import {TextEditor} from '~library/organisms/TextEditor';

import './WriteMessage.sass';

export const WriteMessage = ({
  onBack,
  onNext,
  selectedUserIds,
  volunteersMap,
  message,
  setMessage,
}) => {
  const toolbarId = 'message-volunteers-toolbar';

  const handleNext = useCallback(() => {
    onNext();
  }, [onNext]);

  // Check if message is empty by removing HTML tags and whitespace
  const isMessageEmpty = !message?.replace(/<[^>]*>/g, '').trim();

  return (
    <div className="message-volunteers__step">
      <div className="message-volunteers__content">
        <TextEditor
          value={message}
          onChange={setMessage}
          placeholder="Write a message"
          data-qa-id="message-volunteers-text-editor"
          className="message-volunteers__text-editor"
          allowUnderline
          toolbarId={toolbarId}
          containerClassName="write-message__container"
          toolbarAlign="left"
        />

        <RecipientCount selectedUserIds={selectedUserIds} volunteersMap={volunteersMap} />
      </div>
      <Footer
        onBack={onBack}
        onNext={handleNext}
        nextLabel="Preview message"
        nextDisabled={isMessageEmpty}
      />
    </div>
  );
};
